<template>
    <div class="wrap">
        <listHeader
            :title="postData.cid > 0 ? '编辑教室' : '新增教室'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="教室名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入教室名称" v-decorator="['crname', {rules: [{ required: true, max: 64, message: '请输入教室名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'classroomCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'cid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/classroom/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.cid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            crname: res.data.crname,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.cid > 0) {
                            url = '/manage/classroom/edit';
                            values.cid = this.postData.cid;
                        } else {
                            url = '/manage/classroom/save';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
